import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

import 'swiper/css';

document.addEventListener('DOMContentLoaded', () => {
	const mq = window.matchMedia('(max-width: 699px)');

	for (const element of document.querySelectorAll('.swiper.customer-highlight-stats-slider')) {
		const wrapper = element.querySelector('.swiper-wrapper');
		if (!wrapper || wrapper.children.length === 0) {
			continue;
		}

		/* The pristine markup, so each (re)build starts from the real stats only */
		const baseHtml = wrapper.innerHTML;
		let swiper = null;

		const activate = () => {
			if (swiper || !mq.matches) {
				return;
			}

			wrapper.innerHTML = baseHtml;
			const originals = [...wrapper.children];

			/* Only a few stats exist, too few for Swiper's loop to stay filled.
			   Duplicate the set until there are plenty of slides. */
			for (const slide of originals) {
				const clone = slide.cloneNode(true);
				clone.setAttribute('aria-hidden', 'true');
				wrapper.append(clone);
			}

			swiper = new Swiper(element, {
				modules: [Autoplay],
				slidesPerView: 'auto',
				spaceBetween: 16,
				loop: true,
				speed: 4000,
				allowTouchMove: false,
				autoplay: {
					delay: 0,
					disableOnInteraction: false,
				},
			});
		};

		const deactivate = () => {
			if (!swiper) {
				return;
			}

			swiper.destroy(true, true);
			swiper = null;
			wrapper.innerHTML = baseHtml;
		};

		/* The stats live in tab panels that are display:none until active. A Swiper
		   initialised or resumed while hidden can't measure itself and its autoplay
		   stalls, so build a fresh instance whenever the panel becomes visible and
		   tear it down when hidden. */
		const observer = new IntersectionObserver(entries => {
			for (const entry of entries) {
				if (entry.isIntersecting) {
					activate();
				} else {
					deactivate();
				}
			}
		});

		observer.observe(element);

		mq.addEventListener('change', event => {
			if (event.matches) {
				activate();
			} else {
				deactivate();
			}
		});
	}
});
